import { LockIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useLogout } from "@/lib/auth";

/**
 * The 402 screen.
 *
 * `TenantSuspensionMiddleware` answers 402 on every authenticated route once a
 * gym's subscription lapses, so the SPA has to say so plainly instead of showing
 * a wall of failed requests.
 */
export function TenantSuspendedScreen({ reason }: { reason?: string }) {
  const { t } = useTranslation();
  const logout = useLogout();

  return (
    <div className="bg-muted/30 flex min-h-svh items-center justify-center p-4">
      <Card className="w-full max-w-lg">
        <CardHeader>
          <div
            className="bg-warning/15 text-warning-foreground dark:text-warning mb-2 flex size-12 items-center justify-center rounded-full"
            aria-hidden="true"
          >
            <LockIcon className="size-6" />
          </div>
          <CardTitle className="text-xl">{t("tenant.suspendedTitle")}</CardTitle>
          <CardDescription>{t("tenant.suspendedBody")}</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          {reason ? (
            <p className="bg-muted rounded-md px-3 py-2 text-sm">
              {t("tenant.suspendedReason", { reason })}
            </p>
          ) : null}
          <p className="text-muted-foreground text-sm">{t("tenant.suspendedContact")}</p>
          <Button
            variant="outline"
            onClick={() => logout.mutate()}
            disabled={logout.isPending}
            className="w-full sm:w-auto"
          >
            {logout.isPending ? t("userMenu.loggingOut") : t("userMenu.logout")}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
